import { FC, PropsWithChildren } from "react";

import {
  AppInsightsContext,
  ReactPlugin
} from "@microsoft/applicationinsights-react-js";

import { initAppInsights } from "./app-insights.utils";

const testMode = process.env.REACT_APP_TEST;

const testLogger = {
  trackEvent: (...args: any[]) => {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
} as ReactPlugin;

export const AnalyticsProvider: FC<PropsWithChildren> = ({ children }) => {
  const appInsightPlugin = testMode ? testLogger : initAppInsights();
  return (
    <AppInsightsContext.Provider value={appInsightPlugin}>
      {children}
    </AppInsightsContext.Provider>
  );
};
